import { HUSidebarContext } from "@modules/sidebar/context/sidebarContext"
import { useContext } from "react"

export const useSidebar = () => {
  const sidebarContext = useContext(HUSidebarContext)

  if (!sidebarContext) {
    throw new Error("useSidebar must be used within a HUSidebarProvider.")
  }

  return {
    ...sidebarContext,
    hideSidebar: (runOnHideCallback?: boolean) => sidebarContext.hideSidebar.current(runOnHideCallback),
  }
}
